import { useNavigate } from "react-router-dom";

import DashboardSection from "./DashboardSection";

import "./RecentDossiers.css";

const STEP_LABELS = {
  aanmelding: "Aanmelding",
  administratie: "Administratie",
  begeleiding: "Begeleiding",
  vdab: "VDAB",
  kld: "KLD",
  afronding: "Afronding",
};

export default function RecentDossiers({ dossiers = [] }) {
  const navigate = useNavigate();

  return (
    <DashboardSection
      title="Recente dossiers"
      description="Laatst bijgewerkte dossiers."
    >
      <div className="recent-dossiers">
        {dossiers.length === 0 ? (
          <div className="recent-dossiers__empty">Geen recente dossiers.</div>
        ) : (
          dossiers.map((dossier) => (
            <button
              key={dossier._id}
              type="button"
              className="recent-dossiers__item"
              onClick={() => navigate(`/dashboard/dossiers/${dossier._id}`)}
            >
              <div>
                <strong>
                  {dossier.client?.display_name || "Onbekende cliënt"}
                </strong>

                <span>
                  {STEP_LABELS[dossier.current_step] ||
                    dossier.current_step ||
                    "-"}
                </span>
              </div>

              <div>
                <small>{dossier.status || "-"}</small>

                <span>
                  {dossier.updatedAt
                    ? new Date(dossier.updatedAt).toLocaleDateString("nl-BE")
                    : "-"}
                </span>
              </div>
            </button>
          ))
        )}
      </div>
    </DashboardSection>
  );
}
